import { Progress as MantineProgress } from '@mantine/core';

export const Progress = MantineProgress.extend({
	defaultProps: {
		animated: true,
		transitionDuration: 500,
	},
});
